import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { XFieldComponent } from '../x-field/x-field.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'x-toggle',
  templateUrl: 'x-toggle.component.html',
  styleUrls: ['./x-toggle.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => XToggleComponent), multi: true }
  ]
})
export class XToggleComponent extends XFieldComponent {

  constructor(
    protected matSnackBar: MatSnackBar
  ) {
    super(matSnackBar);
  }
}
